// extracted by mini-css-extract-plugin
export default {"links_wrapper":"SocialLinks_links_wrapper__m1INu","social_imgs":"SocialLinks_social_imgs__pwq6b"};